var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 584.037,
    height: 584.037,
    viewBox: "0 0 154.526 154.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-126.707 -123.346)scale(1.77513)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.883,
    cy: 96.455,
    rx: 15.784,
    ry: 15.33,
    style: {
      opacity: 0.9969419,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 6.27483034,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.285 272.52c-56.806 0-102.857 46.05-102.857 102.857 0 15.97 2.692 31.588 10.135 44.574l92.722 161.785 92.897-162.146c7.534-13.152 9.96-28.386 9.96-44.213 0-56.806-46.05-102.857-102.857-102.857m0 56.785a35 35 0 0 1 35 35 35 35 0 0 1-35 35 35 35 0 0 1-35-35 35 35 0 0 1 35-35",
    style: {
      opacity: 0.9969419,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.37039369,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "scale(.26458)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnsite);
export default __webpack_public_path__ + "static/media/onsite.11960070e6c1a3bcdb090fc31acd8db6.svg";
export { ForwardRef as ReactComponent };